import { SxProps } from '@mui/material';

export const styledAccordionSummarySx: SxProps = {
	borderBottom: '1px solid',
	borderColor: 'divider',
	padding: '10px',
};
